import Member from '../service/member'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getmyusers(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.getmyusers(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getpointsdetails(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.getpointsdetails(payload), {
        type: 'info',
        success,
        fail
      })
    },
    downloadusers(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.downloadusers(payload), {
        type: 'file',
        success,
        fail
      })
    },
    getdeliveryaddresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.getdeliveryaddresses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getuser(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.getuser(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getmemberscorerules(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.getmemberscorerules(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getmemberlevels(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.getmemberlevels(payload), {
        type: 'list',
        success,
        fail
      })
    },
    creatememberlevelfromtemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.creatememberlevelfromtemplate(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getmemberleveltemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.getmemberleveltemplate(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addmemberlevel(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.addmemberlevel(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletememberlevel(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.deletememberlevel(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatememberlevel(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.updatememberlevel(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addmemberscorerule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.addmemberscorerule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getnotsetedmemberscoretypes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.getnotsetedmemberscoretypes(payload), {
        type: 'info',
        success,
        fail
      })
    },
    updatememberscorerule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.updatememberscorerule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    enablememberscorerule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.enablememberscorerule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    disenablememberscorerule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.disenablememberscorerule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    bindstaff(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.bindstaff(payload), {
        type: 'action',
        success,
        fail
      })
    },
    wxupdateuser(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Member.wxupdateuser(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
